import { useEffect } from "react"
import { FieldValues, useController, UseFormReturn } from "react-hook-form"
import { Lens } from "@hookform/lenses"
import { FormDirtySchemaType } from "@/modules/patients/detail/progress-note/components/progress-note-editable/treatment-plan-section"
import { StoreFormState } from "@/modules/patients/detail/progress-note/hooks/useStoreFormState"

export const useStoreFormEffect = <TFieldValues extends FieldValues, TTransformedValues = TFieldValues>(
  storeFormState: StoreFormState,
  form: UseFormReturn<TFieldValues, unknown, TTransformedValues>,
  formIsDirtyLens: Lens<FormDirtySchemaType["formIsDirty"]>,
) => {
  const { handleSubmit, trigger } = form
  const { field } = useController(formIsDirtyLens.interop())
  const setFormIsDirty = field.onChange

  useEffect(() => {
    if (storeFormState.isDirty) {
      setFormIsDirty(true)
    }

    if (storeFormState.isSubmitted) {
      handleSubmit(() => {})()
    }

    if (storeFormState.hasErrors) {
      trigger()
    }
  }, [handleSubmit, setFormIsDirty, storeFormState, trigger])
}
